import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { GetUserFullName, useGetPathProtocol } from 'helpers';
import { TE } from 'appconstants';
import { CTEPAgentscolumns } from '../gridcolumns';

const CTEPAgents = ({ data }) => (
  <GridTable
    tag={`${TE.ID}ctepstudyagents${TE.TABLE}`}
    title="Study Agents"
    exportTitle={`Study Agents ${useGetPathProtocol()}`}
    columns={CTEPAgentscolumns}
    user={GetUserFullName()}
    rows={data}
    filterable
    sortable
    enableToolbar
    toPdf={false}
    recordPerPage={10}
  />
);

export default CTEPAgents;
